import * as React from 'react';

import {EditPredictiveModelEntityAction} from '~src/predictiveModel/entityActions/EditPredictiveModelEntityAction';
import {IPredictiveModelActions} from '~src/predictiveModel/serverApi/types/IPredictiveModelActions';
import {ModifiedDateMetadata, OwnerMetadata} from '~src/spacesPlatform/components/header/HeaderMetadataRow';
import {ActionsMenuIcon, FavoriteToggleWithCountsIcon} from '~src/spacesPlatform/components/header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/spacesPlatform/components/header/SpaceHeader';
import {ISpaceItemDetailInfo} from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

import {SiteUrlsProps} from '../../bootstrap/redux/selectors/SiteUrlsSelectors';

export interface PredictiveModelSpaceHeaderProps extends SiteUrlsProps {
  readonly itemInfo: ISpaceItemDetailInfo<'predictiveModel'>;
  readonly availableActions: IPredictiveModelActions;
  readonly catalogingOnSiteEnabled: boolean;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
}

export function PredictiveModelSpaceHeader(props: PredictiveModelSpaceHeaderProps): JSX.Element {
  return <ConnectedSpaceHeader
    item={props.itemInfo}
    availableActions={props.availableActions}
    nameRowIcons={
      <React.Fragment>
        {FavoriteToggleWithCountsIcon({
          item: props.itemInfo,
          addToFavorites: props.addToFavorites,
          removeFromFavorites: props.removeFromFavorites,
        })}
        {ActionsMenuIcon(props.itemInfo)}
      </React.Fragment>
    }
    metadataRow={
      <React.Fragment>
        {OwnerMetadata(props.itemInfo.owner, props.urls)}
        {ModifiedDateMetadata(props.itemInfo.updatedAt)}
      </React.Fragment>
    }
    spotlightActions={ [EditPredictiveModelEntityAction] }
  />;
}
